export default __webpack_public_path__ + "static/media/grass.81101168.png";